import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import {
  params, shape, arrayOf, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Heading } from '@thd-olt-component-react/heading';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import styles from './store-directory.module.scss';

const cx = classNames.bind(styles);

const MostSearchedStoresComponent = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('most-searched-stores.ready'); }, []);

  const { data, loading, error } = useDataModel('storeDirectory', {});
  const storeDirectory = data?.storeDirectory?.storeDirectory || [];

  if (loading) {
    return (
      <article>
        <section className={cx('store-directory__header')}>
          <Heading title="Most Searched Stores" underline />
        </section>
        <LoadingPlaceholder
          color="#E0E0E0"
          ready={false}
          rows={20}
          showLoadingAnimation
          style={{ height: 900 }}
          type="text"
        ><div />
        </LoadingPlaceholder>
      </article>
    );
  }
  if (!storeDirectory?.length || error) return null;

  return (
    <article className={cx('store-directory')}>
      <section className={cx('store-directory__header')}>
        <Heading title="Most Searched Stores" underline />
        <p className={cx('store-directory__header-item')}>
          The Home Depot provides affordable and convenient home improvement resources, supplies
          and solutions through hundreds of stores located across the country.
        </p>
        <p className={cx('store-directory__header-item')}>
          Below, you can view a list of our Most Searched Stores. Click on a store to see more
          details or use our <a href="/l/">Store Finder</a> to find The Home
          Depot store nearest you.
        </p>
      </section>

      <section className={cx('store-directory__state-wrapper')}>
        {storeDirectory.map(({ stateName, stateLink, mostSearchedStores }, stateIndex) => {
          return (
            <div className={cx('store-directory__state')} key={`${stateName}-${stateIndex}`}>
              <a
                className={styles['store-directory__state-link']}
                id={`${stateName}-${stateIndex}`}
                href={stateLink}
              >
                {stateName}
              </a>
              <ul className={cx('store-directory__city-wrapper')}>
                {(mostSearchedStores || []).map(({ name: storeName, storeDetailsPageLink }, storeIndex) => {
                  return (
                    <li key={`${stateName}-${storeName}-${storeIndex}`}>
                      <a
                        className={cx('store-directory__city-link')}
                        id={`${stateName}-${storeName}-${storeIndex}`}
                        href={storeDetailsPageLink}
                      >
                        {storeName}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </section>
    </article>
  );
};

MostSearchedStoresComponent.displayName = 'MostSearchedStores';

const dataModel = {
  storeDirectory: params().shape({
    storeDirectory: arrayOf(shape({
      stateName: stringType(),
      stateLink: stringType(),
      mostSearchedStores: arrayOf(shape({
        name: stringType(),
        storeDetailsPageLink: stringType(),
      }))
    }))
  })
};
MostSearchedStoresComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'most-searched-stores',
  placeholder: (
    <LoadingPlaceholder
      color="#E0E0E0"
      ready={false}
      style={{ height: 900 }}
      type="text"
    ><div />
    </LoadingPlaceholder>
  ),
  scrollBuffer: 100,
}, MostSearchedStoresComponent);

const MostSearchedStores = withDynamicComponent(HydratedComponent);

MostSearchedStores.dataModel = dataModel;

export { MostSearchedStores };
